import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Form, Row, Typography, message } from "antd";
import UserDetailAvatar from "./component/user_detail_avatar";
import UserDetailStatus from "./component/user_detail_status";
import UserDetailRoster from "./component/user_detail_roster";
import UseDetailUserName from "./component/user_detail_user_name";
import UserDetailCode from "./component/user_detail_code";
import UserDetailFirstName from "./component/user_detail_first_name";
import UserDetailLastName from "./component/user_detail_last_name";
// import UserDetailPhone from "./component/user_detail_phone";
// import UserDetailEmail from "./component/user_detail_email";
import UserDetailDOB from "./component/user_detail_dob";
import UserDetailLevel from "./component/user_detail_level";
import UserDetailPassword from "./component/user_detail_password";
import UserDetailPasswordConfirm from "./component/user_detail_password_confirm";
import moment from "moment";
import { updateUserById } from "../../../store/user/user.action";
import { useDispatch } from "react-redux";

const { Title } = Typography;
const UserDetail = (props) => {
  // -------------------------- VAR --------------------------
  const { detail, setDetail, add, setAdd } = props;
  // -------------------------- STATE --------------------------
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(true);
  const [avatar, setAvatar] = useState("");
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  const handleCancel = () => {
    form.resetFields();
    setDisabled(true);
    setAdd(false);
    setDetail(null);
    setAvatar("");
  };

  const handleEdit = () => {
    setDisabled(false);
  };

  const onFinishFailed = () => {
    console.log("onFinishFailed");
  };

  const onFinish = (values) => {
    const dob = moment(values?.dob).format("DD/MM/YYYY");
    const update = { ...values, avatar, dob };
    setLoading(true);
    if (!add && detail) {
      dispatch(
        updateUserById({ update, detail }, (response) => {
          setLoading(false);
          if (response.status === 500) {
            message.error(response.data || "Error, Please try again!");
          } else {
            message.success("The user's info was update!");
            setDisabled(true);
          }
        })
      );
    } else {
      console.log("new");
      const register = {
        email: values?.email,
        password: values?.password,
      };
      console.log({ register });
      // dispatch(
      //   registerEmailPassword({ register }, (res) => {
      //     console.log({ res });
      //     setLoading(false)
      //     setDisabled(true);
      //     setAdd(false)
      //   })
      // );
    }
  };

  const onSelect = (value) => {
    setAvatar(value);
  };
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (detail) {
      // console.log({ detail });
      const dob = moment(detail?.dob || "01/01/2000", "DD/MM/YYYY");
      form.setFieldsValue({ ...detail, dob });
      setDisabled(true);
      setAvatar(detail?.avatar || avatar);
      setAdd(false);
    }
  }, [detail]);

  useEffect(() => {
    if (add) {
      setDisabled(false);
      setDetail(null);
      setAvatar("");
      form.resetFields();
    }
  }, [add]);
  // -------------------------- RENDER --------------------------
  const renderTitle = () => {
    return <Title level={4}>User Details</Title>;
  };
  const renderAvatar = () => {
    return (
      <Row gutter={[20, 20]}>
        <Col span={6}>
          <UserDetailAvatar
            onSelect={onSelect}
            avatar={avatar}
            disabled={disabled}
          />
        </Col>
        <Row gutter={[20, 0]}>
          <Col span={8}>
            <UserDetailStatus disabled={disabled} />
          </Col>
          <Col span={24}>
            <UserDetailRoster disabled={disabled} />
          </Col>
        </Row>
      </Row>
    );
  };
  const renderUserInfo = () => {
    return (
      <Row gutter={[10, 0]}>
        <Col span={12}>
          <UseDetailUserName disabled={disabled} />
        </Col>
        <Col span={12}>
          <UserDetailCode disabled={disabled} />
        </Col>
        <Col span={12}>
          <UserDetailFirstName disabled={disabled} />
        </Col>
        <Col span={12}>
          <UserDetailLastName disabled={disabled} />
        </Col>
        {/* <Col span={12}>
          <UserDetailPhone disabled={disabled} />
        </Col>
        <Col span={12}>
          <UserDetailEmail disabled={disabled} />
        </Col> */}
        <Col span={12}>
          <UserDetailDOB disabled={disabled} />
        </Col>
        <Col span={12}>
          <UserDetailLevel disabled={disabled} />
        </Col>
        {renderPassword()}
        {renderButton()}
      </Row>
    );
  };

  const renderPassword = () => {
    if (add) {
      return (
        <>
          <Col span={12}>
            <UserDetailPassword disabled={disabled} />
          </Col>
          <Col span={12}>
            <UserDetailPasswordConfirm disabled={disabled} />
          </Col>
        </>
      );
    }
    return null;
  };

  const renderButton = () => {
    if (disabled) {
      return (
        <Col span={24} align="right">
          <Row gutter={[10, 10]} justify="end">
            <Col span={6}>
              <Button
                type="primary"
                block
                onClick={handleEdit}
                disabled={!detail}
                loading={loading}
              >
                Edit
              </Button>
            </Col>
          </Row>
        </Col>
      );
    } else {
      return (
        <Col span={24} align="right">
          <Row gutter={[10, 10]} justify="end">
            <Col span={6}>
              <Button
                type="default"
                disabled={disabled}
                block
                onClick={handleCancel}
                loading={loading}
              >
                Cancel
              </Button>
            </Col>
            <Col span={6}>
              <Button
                type="primary"
                disabled={disabled}
                block
                form="detail-staff-form"
                htmlType="submit"
                loading={loading}
              >
                Save
              </Button>
            </Col>
          </Row>
        </Col>
      );
    }
  };
  // -------------------------- MAIN --------------------------
  return (
    <Col span={24}>
      <Form
        id="detail-staff-form"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        form={form}
        type="basic"
        layout="vertical"
        autoComplete="off"
      >
        <Row gutter={[20, 20]}>
          <Col span={24}>{renderTitle()}</Col>
          <Col span={12}>{renderAvatar()}</Col>
          <Col span={12}>{renderUserInfo()}</Col>
        </Row>
      </Form>
    </Col>
  );
};
export default UserDetail;
